import { useEffect } from "react";
import { CONSTANT } from "../utils/UrlContants";
import Swal from "sweetalert2";

interface MessageTypes {
  type: number;
  msg: string;
  details?: string;
  callback?: () => void;
}

const MessageManager = ({ type, msg, details, callback }: MessageTypes) => {
  useEffect(() => {
    showMessage();
    // eslint-disable-next-line
  }, []);

  const showMessage = () => {
    Swal.fire({
      title: `<span style="font-weight: 400">${msg}</span>`,
      text: details,
      icon: type === CONSTANT.ERROR_MSG ? "error" : "success",
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#CC0000",
    }).then(() => callback && callback());
  };

  return <></>;
};

export default MessageManager;
